import { Component, OnDestroy } from "@angular/core";

import {
    ActivatedRoute,
    NavigationEnd,
    Router,
    RouterOutlet,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "./reducers/app.reducer";
import * as UserActions from "./actions/user.actions";
import { filter, Subscription } from "rxjs";
import { SeoService } from "./services/seo.service";
import { GoogleAnalyticsService } from "ngx-google-analytics";

//
@Component({
    selector: "app-root",
    imports: [RouterOutlet],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent implements OnDestroy {
    title = "home-shark";

    public test = false;

    private subscriptions: Array<Subscription> = [];

    constructor(
        private store: Store<AppState>,
        public route: ActivatedRoute,
        public router: Router,
        public seo: SeoService,
        private gaService: GoogleAnalyticsService
    ) {
        store.dispatch(UserActions.loadUser());
        this.appendSeoRoutePipe();
        this.gaService.event("page_view", "page_category", "Landing Page");
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.forEach((s) => s.unsubscribe());
        }
    }

    private appendSeoRoutePipe() {
        this.subscriptions.push(
            this.router.events
                .pipe(
                    filter(
                        (event): event is NavigationEnd =>
                            event instanceof NavigationEnd
                    )
                )
                .subscribe(() => {
                    const deepestRoute = this.getDeepestRoute();
                    const config = deepestRoute.snapshot.data["seo"];
                    this.seo.addOrRemoveTagsAndTitle(config);
                })
        );
    }

    private getDeepestRoute() {
        let currentRoute = this.route;

        while (currentRoute.firstChild) {
            currentRoute = currentRoute.firstChild;
        }
        return currentRoute;
    }
}
